import { IAirline } from '@simplyfly/shared';
import { getCotationAirline } from './enquiry.helpers';
import { IEnquiryCotation } from '@simplyfly/shared';
export const getAirlineIdFromCotation = (enquiryCotation: IEnquiryCotation): string | null => {
  const airline: IAirline | null = getCotationAirline(enquiryCotation);

  if (airline) {
    return airline.id;
  } else if (enquiryCotation.aircraftCompiledId) {
    const splittedAircraftCompiledId: string[] = enquiryCotation.aircraftCompiledId.split('-');

    return splittedAircraftCompiledId[0];
  }

  return null;
};
